<template>
  <div class="tab">
    <div class="tab-title-container">
      <h3
        v-for="tab in tabs"
        :key="tab.id"
        :class="clsx('tab-title', { 'tab-title--active': activeTab === tab.id })"
        @click="() => setActiveTab(tab.id)"
      >
        {{ tab.title }}
      </h3>
    </div>
    <div class="tab-content-container">
      <transition name="fade" mode="out-in">
        <template v-for="tab in tabs">
          <div v-if="activeTab === tab.id" :key="tab.id">
            <slot :name="tab.id" />
          </div>
        </template>
      </transition>
    </div>
  </div>
</template>

<script>
import clsx from 'clsx';

export default {
  props: {
    tabs: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      activeTab: null,
    };
  },
  methods: {
    clsx,
    getActiveTab() {
      return this.activeTab;
    },
    setActiveTab(activeTabId) {
      if (this.activeTab !== activeTabId) {
        this.activeTab = activeTabId;
        this.$emit('tab-change', activeTabId);
      }
    },
  },
};
</script>

<style scoped lang="scss">
.tab {
  &-title {
    font-size: 14px;
    font-weight: 600;
    color: #09090B;
    cursor: pointer;
    padding-bottom: 10px;

    &--active {
      padding-bottom: 8px;
      border-bottom: 2px solid #FB923C;
    }

    & + & {
      margin-left: 64px;

      @media (max-width: 500px) {
        margin-left: 20px;
      }
    }
  }
}

.tab-title-container {
  display: flex;
  justify-content: center;
  align-items: center;
}

.tab-content-container {
  margin-top: 24px;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
